import React, { useEffect } from 'react'

import moment from 'moment'
import ShiftsManager from '../../Components/shared/ShiftsManager/ShiftsManager'
import Analytics from '../../utils/analytics'
import { DATE_FORMAT_API } from '../../utils/constants'
import ShiftManagerProvider from '../../Providers/ShiftManagerProvider'

import '../../assets/internships-manager.scss'
import SelectProvider from '../../Providers/SelectProvider'

const NUMBER_OF_WEEK_TO_PRELOAD = 0

const ShiftsManagerView = ({ currentDate, displayManagePresets }) => {
  const start = currentDate || moment().startOf('isoWeek').hours(0).minutes(0).seconds(0)
  const end = start.clone().add(3, 'week').endOf('isoWeek').add(NUMBER_OF_WEEK_TO_PRELOAD, 'week')

  useEffect(() => {
    Analytics.pageView('/institution-shift-manager')
  }, [])

  return (
    <ShiftManagerProvider>
      <SelectProvider>
        <ShiftsManager
          start={start.format(DATE_FORMAT_API)}
          end={end.format(DATE_FORMAT_API)}
          displayManagePresets={displayManagePresets}
        />
      </SelectProvider>
    </ShiftManagerProvider>
  )
}

export default ShiftsManagerView
